import React from 'react'
import _ from 'lodash'

import {Row, Col} from 'react-flexbox-grid'

import {SetupGuide, SetupSteps} from '../../setup-guide'
import {Loading} from 'ui'
import {Form, Submit, Reset} from 'forms'

import {NetworkService} from 'api/network'

import Info from './Info.jsx'
import Types from './Types.jsx'
import Channels from './Channels.jsx'

export class Overview extends React.Component {
   static get propTypes() {
      return {
         network: React.PropTypes.object.isRequired,
         router:  React.PropTypes.object.isRequired,
         routes:  React.PropTypes.array.isRequired,
         params:  React.PropTypes.object.isRequired
      }
   }

   static get defaultProps() {
      return {
         network: {}
      }
   }

   constructor(props) {
      super(props)

      this.ignoreSetup = this.ignoreSetup.bind(this)
      this.gotoSetup = this.gotoSetup.bind(this)
      this.handleSubmit = this.handleSubmit.bind(this)
   }

   ignoreSetup() {
      SetupGuide.skipSetup(this.props.network)
      this.forceUpdate()
   }

   gotoSetup() {
      let {router, params, routes} = this.props,
         newRoutes = _.slice(routes, 0, -1).concat([{path: 'setup'}]),
         nextPath = _.map(newRoutes, r => r.path).join('/').replace('//', '/'),
         url

      url = _.reduce(params, (acc, v, k) => acc.replace(':' + k, v), nextPath)

      router.push(url)
   }

   handleSubmit(ev, patch) {
      ev.preventDefault()

      const {key} = this.props.network

      return NetworkService.update(key, patch)
   }

   render() {
      let {network, ...props} = this.props

      return (
         <Loading loading={_.eq({}, network)}>
            <div className="network overview">
               <div
                  style={{
                     marginBottom: '1rem',
                     display:      SetupGuide.setupFinished(network) ? 'none' : 'inherit'
                  }}
               >
                  <div>
                     <button onClick={this.ignoreSetup} type="button" className="close">
                        <span style={{fontSize: '12px', verticalAlign: 'middle'}}>
                           Ignore
                        </span>
                        &nbsp;
                        <span aria-hidden="true">×</span>
                     </button>
                  </div>

                  <div
                     onClick={this.gotoSetup}
                     style={{clear: 'both', marginTop: '1rem', opacity: 0.5}}
                  >

                     <SetupSteps link={true} network={network} {...props} />
                  </div>
               </div>

               <Form
                  onSubmit={this.handleSubmit}
                  transform={input => _.omit(input, (v, k) => k.match(/^\$/))}
                  input={network}
               >

                  <Form.Updated>Network was successfully updated</Form.Updated>

                  <Form.Error>
                     <h5>Failed to update network</h5>
                  </Form.Error>

                  <Row>
                     <Col md={6}>
                        <Info network={network} />
                     </Col>
                     <Col md={6}>
                        <Channels network={network} />
                     </Col>
                  </Row>

                  <Row>
                     <Col md={12}>
                        <Types network={network} />
                     </Col>
                  </Row>

                  <div style={{clear: 'both'}}>
                     <Submit>Update Network</Submit>
                     <Reset>Reset Form</Reset>
                  </div>
               </Form>
            </div>
         </Loading>
      )
   }
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/network/overview/index.jsx